// extracted by mini-css-extract-plugin
export var card = "J_cr";
export var cardContainer = "J_cq";
export var infoBoxList = "J_cp";
export var textContainer = "J_cs";
export var title = "J_bH";